import { combineReducers } from 'redux';

import colors from './theme/colors';
import error from './theme/error';

const theme = combineReducers({
  colors,
  error,
});

export default theme;



// WEBPACK FOOTER //
// ./src/modules/app/reducers/theme.reducer.js